"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const one_2 = require("../one");
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('images');
const Images = (props) => {
    const { data = [] } = props;
    const handleClickImage = (index) => {
        let urls = data;
        const current = index;
        if (typeof data[index] !== 'string') {
            urls = data.map(i => i.url);
        }
        one_2.previewImage({
            urls: urls,
            current,
            // @ts-ignore
            enablesavephoto: true,
            enableShowPhotoDownload: true,
        });
    };
    return (React.createElement(one_1.View, { className: prefixCls }, data &&
        data.map((item, index) => (React.createElement(one_1.View, { key: item.key || index, className: `${prefixCls}-item`, onTap: () => handleClickImage(index) },
            React.createElement(one_1.Image, { mode: "widthFix", src: item.url || item }))))));
};
exports.default = Images;
